import { Component, Vue } from 'vue-property-decorator';
import { VehicleStateTranslatableValue } from '@/core/interfaces/vehicleState';
import { VehicleType } from '@/core/interfaces/vehicleType';
import { Getter } from 'vuex-class';

@Component
export default class UsesTranslatableValue extends Vue {
    @Getter('vehicleDashboard/vehicleType')
    vehicleType!: VehicleType;

    private translate(key: string, args?: {k: string; v: string}[]): string {
        const t = `phone.${this.vehicleType.id}.${key.substring(1, key.length - 1)}`;

        const values = args ? args.reduce((acc: Record<string, string>, arg) => {
            acc[arg.k] = arg.v;

            return acc;
        }, {}) : undefined;

        return this.$t(t, values).toString();
    }

    public displayValue(value: VehicleStateTranslatableValue | string): string {
        const key = typeof value === 'string' ? value : value.t;

        if (key.startsWith('{') && key.endsWith('}')) {
            return this.translate(key, typeof value === 'string' ? undefined : value.args);
        }

        return key;
    }
}
